import { Card } from 'react-bootstrap';

// One lightweight section card for the compact mobile tree: title + simple
// internal rows, no nested cards/inputs. Callers decide whether a section
// has any content worth showing (see emptyValue.hasAnyValue) before
// rendering this — it does not hide itself.
const CompanyDetailSection = ({ title, number, showSeparator = true, showSeparatorWithoutNumber = false, className = '', children }) => (
    <Card className={`company-detail-section mb-4 ${className}`.trim()}>
        <Card.Body>
            {title && (
                <h3 className="company-detail-section-title">
                    {number && <span className="item-number">{number}.</span>}
                    {title}
                </h3>
            )}
            {showSeparator && (number || showSeparatorWithoutNumber) && <hr />}
            {children}
        </Card.Body>
    </Card>
);

export default CompanyDetailSection;
